"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localLogger = localLogger;
exports.spacedLogger = spacedLogger;

function localLogger() {
  var _window, _window$location, _window$location$host;

  if ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$host = _window$location.host) === null || _window$location$host === void 0 ? void 0 : _window$location$host.includes('localhost')) {
    var _console;

    (_console = console).log.apply(_console, arguments);
  }
}

function spacedLogger() {
  var _console2;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  (_console2 = console).log.apply(_console2, ['\n\n\n\n\n\n\n\n\n\n'].concat(args, ['\n\n\n\n\n\n\n\n\n\n']));
}